import { render, staticRenderFns } from "./languageSelect.vue?vue&type=template&id=28424018&scoped=true&"
import script from "./languageSelect.vue?vue&type=script&lang=js&"
export * from "./languageSelect.vue?vue&type=script&lang=js&"
import style0 from "./languageSelect.vue?vue&type=style&index=0&id=28424018&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28424018",
  null
  
)

export default component.exports